import React from 'react';
import CountrySelect from '../common/CountrySelect/CountrySelect';
import { countries } from '../../utils/countries';

export const countryNameToCode = (name: string): string | null =>
  countries.find(c => c.name.toLowerCase() === name.toLowerCase())?.code ?? null;

export const countryCodeToName = (code: string): string =>
  countries.find(c => c.code === code)?.name ?? '';

interface LocationStepContentProps {
  country: string | null;
  region: string | null;
  onChange: (country: string | null, region: string | null) => void;
}

const LocationStepContent: React.FC<LocationStepContentProps> = ({ country, region, onChange }) => {
  const isMulti = country === 'multi';
  const countryNameValue = country && !isMulti ? countryCodeToName(country) : '';

  return (
    <div>
      <div className="mb-4">
        <CountrySelect
          value={countryNameValue}
          onChange={name => onChange(countryNameToCode(name), region)}
          placeholder="Select a country..."
          disabled={isMulti}
        />
      </div>

      {!isMulti && (
        <div className="mb-4">
          <input
            type="text"
            value={region ?? ''}
            onChange={e => onChange(country, e.target.value || null)}
            placeholder="City or region (optional)"
            className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition"
          />
        </div>
      )}

      <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
        <input
          type="checkbox"
          checked={isMulti}
          onChange={e => onChange(e.target.checked ? 'multi' : null, e.target.checked ? null : region)}
          className="rounded border-gray-300 text-primary focus:ring-primary"
        />
        Several countries
      </label>
    </div>
  );
};

export default LocationStepContent;
